{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "निर्धारित",
      "confirmed": "पुष्ट",
      "completed": "पूर्ण",
      "cancelled": "रद्द",
      "no-show": "अनुपस्थित",
      "checked-in": "चेक-इन हो गया"
    },
    "resultStatus": {
      "final": "अंतिम",
      "preliminary": "प्रारंभिक",
      "corrected": "सुधारा गया"
    },
    "allergySeverity": {
      "severe": "गंभीर",
      "high": "उच्च",
      "moderate": "मध्यम"
    },
    "nationalIdType": {
      "NRIC": "NRIC (सिंगापुर)",
      "HKID": "HKID (हांगकांग)",
      "MyKad": "MyKad (मलेशिया)",
      "Aadhaar": "आधार (भारत)",
      "KTP": "KTP (इंडोनेशिया)",
      "Passport": "पासपोर्ट"
    },
    "messageSenderType": {
      "provider": "चिकित्सक",
      "patient": "रोगी"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "पासवर्ड मेल नहीं खाते",
      "passwordMinLength": "पासवर्ड कम से कम 8 वर्णों का होना चाहिए"
    }
  },
  "labels": {
    "abnormal": "असामान्य"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "मेरा स्वास्थ्य",
        "results": "परिणाम",
        "appointments": "अपॉइंटमेंट",
        "messages": "संदेश",
        "forms": "फ़ॉर्म"
      },
      "signOut": "साइन आउट",
      "signOutAria": "साइन आउट",
      "navAria": "पोर्टल नेविगेशन",
      "footer": "VynaEMR रोगी पोर्टल — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "रोगी पोर्टल",
      "labels": {
        "email": "ईमेल",
        "password": "पासवर्ड"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "अपना पासवर्ड दर्ज करें"
      },
      "button": {
        "signIn": "साइन इन करें",
        "signingIn": "साइन इन हो रहा है..."
      },
      "toast": {
        "welcome": "वापसी पर स्वागत है!",
        "invalid": "अमान्य ईमेल या पासवर्ड"
      },
      "links": {
        "noAccount": "खाता नहीं है?",
        "register": "रजिस्टर करें"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "सुप्रभात",
        "afternoon": "नमस्कार",
        "evening": "शुभ संध्या",
        "fallbackName": "आप"
      },
      "subtitle": "यहाँ आपका स्वास्थ्य सारांश है।",
      "error": "आपका स्वास्थ्य सारांश लोड नहीं हो सका। कृपया बाद में पुनः प्रयास करें।",
      "demographics": {
        "ageLabel": "आयु {{age}}",
        "bloodTypeLabel": "रक्त समूह: {{bloodType}}"
      },
      "quickLinks": {
        "results": "परिणाम",
        "appointments": "अपॉइंटमेंट",
        "messages": "संदेश",
        "forms": "फ़ॉर्म"
      },
      "sections": {
        "allergies": "एलर्जी",
        "activeMedications": "वर्तमान दवाएँ",
        "activeProblems": "वर्तमान समस्याएँ",
        "upcomingAppointments": "आगामी अपॉइंटमेंट",
        "recentResults": "हाल के परिणाम",
        "immunizations": "टीकाकरण रिकॉर्ड",
        "emergencyContact": "आपातकालीन संपर्क"
      },
      "states": {
        "noAllergies": "कोई ज्ञात एलर्जी दर्ज नहीं है।",
        "noMedications": "कोई वर्तमान दवा नहीं है।",
        "noAppointments": "कोई आगामी अपॉइंटमेंट नहीं है।",
        "noResults": "कोई हाल का परिणाम नहीं है।"
      },
      "moreCount": "+{{count}} और",
      "sinceDate": "{{date}} से",
      "doseNumber": "खुराक {{number}}",
      "viewAll": "सभी देखें",
      "providerTBD": "चिकित्सक निर्धारित नहीं"
    },
    "register": {
      "subtitle": "अपना खाता बनाएँ",
      "labels": {
        "fullName": "पूरा नाम",
        "email": "ईमेल",
        "dateOfBirth": "जन्म तिथि",
        "phone": "फ़ोन",
        "mrn": "MRN (मेडिकल रिकॉर्ड नंबर)",
        "idType": "पहचान पत्र का प्रकार",
        "idNumber": "पहचान पत्र संख्या",
        "password": "पासवर्ड",
        "confirmPassword": "पासवर्ड की पुष्टि करें"
      },
      "placeholders": {
        "fullName": "अपना पूरा नाम दर्ज करें",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "अपनी पहचान पत्र संख्या दर्ज करें",
        "password": "कम से कम 8 वर्ण",
        "confirmPassword": "अपना पासवर्ड फिर से दर्ज करें",
        "selectIdType": "चुनें..."
      },
      "mrnHint": "अपने खाते को मेडिकल रिकॉर्ड से जोड़ने के लिए, कृपया अपना MRN या राष्ट्रीय पहचान पत्र संख्या दर्ज करें।",
      "button": {
        "createAccount": "खाता बनाएँ",
        "creatingAccount": "खाता बनाया जा रहा है..."
      },
      "toast": {
        "success": "पंजीकरण सफल रहा। कृपया साइन इन करें।",
        "failure": "पंजीकरण विफल रहा। कृपया पुनः प्रयास करें।"
      },
      "links": {
        "haveAccount": "पहले से खाता है?",
        "signIn": "साइन इन करें"
      },
      "aria": {
        "dateOfBirth": "जन्म तिथि"
      }
    },
    "appointments": {
      "title": "अपॉइंटमेंट",
      "subtitle": "अपने अपॉइंटमेंट देखें और प्रबंधित करें",
      "error": "अपॉइंटमेंट लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
      "sections": {
        "upcoming": "आगामी",
        "past": "पिछले"
      },
      "states": {
        "noUpcoming": "कोई आगामी अपॉइंटमेंट नहीं है।",
        "noPast": "कोई पिछले अपॉइंटमेंट नहीं हैं।"
      },
      "reasonLabel": "कारण: {{reason}}",
      "instructionsLabel": "निर्देश: {{instructions}}",
      "durationMinutes": "{{minutes}} मिनट",
      "actions": {
        "cancel": "रद्द करें",
        "confirmCancel": "पुष्टि करें",
        "cancelling": "रद्द किया जा रहा है...",
        "keep": "रहने दें"
      },
      "toast": {
        "cancelSubmitted": "रद्द करने का अनुरोध भेज दिया गया है। आपकी देखभाल टीम पुष्टि करेगी।",
        "cancelFailed": "अपॉइंटमेंट रद्द नहीं हो सका। कृपया कार्यालय को फ़ोन करें।"
      }
    },
    "results": {
      "title": "मेरे परिणाम",
      "subtitle": "अपनी लैब और इमेजिंग रिपोर्ट देखें",
      "error": "परिणाम लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
      "referenceRange": "(संदर्भ: {{range}})",
      "states": {
        "noResults": "कोई परिणाम उपलब्ध नहीं है।"
      }
    },
    "messages": {
      "title": "संदेश",
      "subtitle": "अपनी देखभाल टीम से संवाद करें",
      "error": "संदेश लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
      "fromSender": "{{name}} से",
      "labels": {
        "subject": "विषय",
        "message": "संदेश",
        "reply": "उत्तर"
      },
      "placeholders": {
        "subject": "संदेश का विषय",
        "message": "अपना संदेश लिखें...",
        "reply": "अपना उत्तर लिखें..."
      },
      "actions": {
        "newMessage": "नया संदेश",
        "back": "संदेशों पर वापस जाएँ",
        "sendMessage": "संदेश भेजें",
        "sendReply": "उत्तर भेजें",
        "sending": "भेजा जा रहा है..."
      },
      "states": {
        "noMessages": "अभी तक कोई संदेश नहीं है।"
      },
      "thread": {
        "fromSenderWithType": "{{name}} ({{type}}) से"
      },
      "compose": {
        "title": "नया संदेश",
        "subtitle": "आपका संदेश आपकी देखभाल टीम को भेजा जाएगा।"
      },
      "toast": {
        "sent": "संदेश भेज दिया गया",
        "sendFailed": "संदेश भेजने में विफल"
      }
    },
    "forms": {
      "title": "फ़ॉर्म",
      "subtitle": "आवश्यक फ़ॉर्म और प्रश्नावलियाँ भरें",
      "error": "फ़ॉर्म लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
      "sections": {
        "pending": "लंबित",
        "completed": "पूर्ण"
      },
      "labels": {
        "required": "आवश्यक"
      },
      "placeholders": {
        "select": "चुनें..."
      },
      "actions": {
        "fillOut": "भरें",
        "back": "फ़ॉर्म पर वापस जाएँ",
        "submit": "फ़ॉर्म सबमिट करें",
        "submitting": "सबमिट किया जा रहा है..."
      },
      "states": {
        "noPending": "कोई लंबित फ़ॉर्म नहीं है।",
        "noCompleted": "कोई पूर्ण फ़ॉर्म नहीं है।",
        "noFields": "इस फ़ॉर्म में भरने के लिए कोई फ़ील्ड नहीं है।"
      },
      "toast": {
        "submitted": "फ़ॉर्म सफलतापूर्वक सबमिट किया गया",
        "submitFailed": "फ़ॉर्म सबमिट करने में विफल"
      }
    }
  }
}
